import declare from "dojo/_base/declare";
import HomePageUtil from "./util";
import NewSupplierPortalPaneForm from "./NewSupplierPortalPaneForm";

const NewSupplierPortalSourcingPaneForm = declare(NewSupplierPortalPaneForm, {
	allowedPaneIds: [
		"HomeFactory",
		"HomeFoodSample",
		"HomeFoodSupplierItem",
		"HomeFormulatedMaterialSample",
		"HomeFormulatedMaterialSupplierItem",
		"HomeOrder",
		"HomePurchasedOrder",
		"HomeSample",
		"HomeSupplierItem",
	],

	/**
	 * @override
	 * Return context types of views that are allowed for selection in this form
	 */
	getContextTypes(): string[] {
		return [HomePageUtil.DOMAIN];
	},
});

export = NewSupplierPortalSourcingPaneForm;